// extracted by mini-css-extract-plugin
export default {"root":"PlasmicIFrame_root__lbUnh","canvasView":"PlasmicIFrame_canvasView__V6NPj"};